"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function respond(isError, response, callback) {
    if (typeof callback == "function") {
        if (isError) {
            callback(response, null);
        }
        else {
            callback(null, response);
        }
    }
}
exports.default = respond;
